import type { PendingTaskRow, PendingTaskTier } from '@/types/pendingTasks';
import { formatDate, formatDaySpan } from '@/utils/formatters';

// Display derivation (titles, entity names, category, tier, sorting, filtering)
// now lives in the backend read service - it returns ready-to-render rows. The
// only thing left to format per row is the relative-due badge.

export interface DueDisplay {
  tier: PendingTaskTier;
  text: string;
  title: string;
}

// Tier is binary: overdue, or due soon (everything not yet overdue).
function dueText(tier: PendingTaskTier, daysUntilDue: number): string {
  if (tier === 'overdue') return `${formatDaySpan(daysUntilDue)} overdue`;
  if (daysUntilDue === 0) return 'Due today';
  return `Due in ${formatDaySpan(daysUntilDue)}`;
}

export function dueDisplayFor(row: PendingTaskRow): DueDisplay {
  const { tier } = row;
  const { days_until_due: daysUntilDue, due_date: dueDate } = row.task;
  return {
    tier,
    text: dueText(tier, daysUntilDue),
    title: `Due ${formatDate(dueDate)}`,
  };
}
